import React from 'react';
import { TableHeading, TableHeader, TableRow } from '@insurancemenu/imenu-components-lib';
import { createStyles } from './styles';

const WebFormsTableHeader = (): JSX.Element => {
  const classes = createStyles();
  return (
    <TableHeader className={classes.tableHeader}>
      <TableRow>
        <TableHeading className={classes.tableHeading}>Form</TableHeading>
        <TableHeading className={classes.tableHeading}>Benefit</TableHeading>
        <TableHeading className={classes.tableHeading}>Status</TableHeading>
        <TableHeading className={classes.tableHeading}> </TableHeading>
      </TableRow>
    </TableHeader>
  );
};

export default WebFormsTableHeader;
